import React, { useState , useEffect } from "react";
import Popover from "@mui/material/Popover";
import Backdrop from "@mui/material/Backdrop";

// import { Popover } from "@mui/material";

export default function UIPopper({
  children,
  clickNode,
  onClose,
  style,
  closePopover,
  anchorOrigin = {
    vertical: "bottom",
    horizontal: "center",
  },
  transformOrigin = {
    vertical: "top",
    horizontal: "right",
  },
  sx = {},
  paperClasses = "custom-scroll",
  onHover = false,
  id = "simple-popover",

  // Control popover from parent
  open: openFromParent,
  anchorEl: anchorFromParent,
  backdrop = false,
}) {
  const [anchorFromClick, setAnchorFromClick] = useState(null);

  const parentControlsOpen = openFromParent !== undefined;
  const anchorEl = parentControlsOpen ? anchorFromParent : anchorFromClick;
  const open = parentControlsOpen ? openFromParent : Boolean(anchorFromClick);

  const handleClick = (event) => {
    if (parentControlsOpen) return;

    event.stopPropagation();
    event.preventDefault();
    setAnchorFromClick(event.currentTarget);
  };

  const handleClose = (e) => {
    e?.stopPropagation();
    e?.preventDefault();

    if (!parentControlsOpen) {
      setAnchorFromClick(null);
    }

    onClose?.();
  };

  // close if parent triggers closePopover
  useEffect(() => {
    if (closePopover && !parentControlsOpen) {
      setAnchorFromClick(null);
    }
  }, [closePopover, parentControlsOpen]);

  // const open = Boolean(anchorEl);
  const compId = open ? id : undefined;

  // determine popover mode: anchorEl if available, else center of screen
  const useAnchorPosition = !anchorEl;

  return (
    <>
      {clickNode &&
        React.cloneElement(clickNode, {
          ...(onHover
            ? {
                onMouseEnter: (event) => {
                  handleClick(event);
                  clickNode?.props?.onMouseEnter?.(event);
                },
                onMouseLeave: (event) => {
                  handleClose(event);
                  clickNode?.props?.onMouseLeave?.(event);
                },
              }
            : {
                onClick: (event) => {
                  handleClick(event);
                  clickNode?.props?.onClick?.(event);
                },
              }),
        })}
      {backdrop && (
        <Backdrop
          sx={{
            zIndex: (theme) => theme.zIndex.modal - 1,
            backdropFilter: "blur(2px)",
          }}
          open={open}
          onClick={handleClose}
        />
      )}
      <Popover
        sx={sx}
        id={compId}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        disableRestoreFocus
        disableAutoFocus
        disableEnforceFocus
        disableScrollLock
        disablePortal={false}
        anchorReference={useAnchorPosition ? "anchorPosition" : "anchorEl"}
        anchorPosition={
          useAnchorPosition
            ? {
                top: window.innerHeight / 2,
                left: window.innerWidth / 2,
              }
            : undefined
        }
        anchorOrigin={anchorOrigin}
        transformOrigin={transformOrigin}
        PaperProps={{ sx: style }}
        classes={{
          paper: paperClasses,
        }}
      >
        {typeof children == "function"
          ? children({ setAnchorEl: setAnchorFromClick })
          : children}
      </Popover>
    </>
  );
}
